import * as Yup from 'yup';

const UUID_V1_TO_V7_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-7][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

Yup.addMethod(Yup.string, 'uuid', function () {
  return this.matches(UUID_V1_TO_V7_REGEX, {
    message: 'Must be a valid UUID',
    name: 'uuid',
    excludeEmptyString: true,
  });
});

declare module 'yup' {
  interface StringSchema {
    uuid(): this;
  }
}

export { Yup };
